var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "create-event-form" } }, [
    Object.keys(_vm.eventDetail).length === 0
      ? _c("div", { staticClass: "tags" }, [
          _c(
            "span",
            {
              staticClass: "tag",
              class: { selected: _vm.selectedTag === "event" },
              on: {
                click: function ($event) {
                  return _vm.changeSelectedTag("event")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("calendar.event")))]
          ),
          _vm._v(" "),
          false
            ? _c(
                "span",
                {
                  staticClass: "tag",
                  class: { selected: _vm.selectedTag === "task" },
                  on: {
                    click: function ($event) {
                      return _vm.changeSelectedTag("task")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("calendar.legacyTaskTag")))]
              )
            : _vm._e(),
          _vm._v(" "),
          false
            ? _c(
                "span",
                {
                  staticClass: "tag",
                  class: { selected: _vm.selectedTag === "schedule" },
                  on: {
                    click: function ($event) {
                      return _vm.changeSelectedTag("schedule")
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("calendar.legacyAppointmentScheduleTag"))
                  ),
                ]
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.selectedTag === "event"
      ? _c(
          "div",
          { staticClass: "event-infos" },
          [
            _c("EventTag", {
              attrs: {
                eventSummary: _vm.eventSummary,
                repeatTimes: _vm.repeatTimes,
                visibilities: _vm.visibilities,
                selectedStartDate: _vm.selectedStartDate,
                selectedEndDate: _vm.selectedEndDate,
                eventDetail: _vm.eventDetail,
                "event-function": _vm.editOrCreateEvent,
                calendarList: _vm.cloneCalendarList,
                refVisitor: _vm.refVisitor,
                footerVisible: _vm.footerVisible,
              },
              on: {
                close: function ($event) {
                  return _vm.$emit("close")
                },
                "delete-event": function ($event) {
                  return _vm.deleteEvent($event)
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.selectedTag === "task"
      ? _c(
          "div",
          { staticClass: "task-infos" },
          [
            _c("TaskTag", {
              attrs: {
                repeatTimes: _vm.repeatTimes,
                eventDetail: _vm.eventDetail,
                "event-function": _vm.editOrCreateEvent,
              },
              on: {
                close: function ($event) {
                  return _vm.$emit("close")
                },
                "delete-event": function ($event) {
                  return _vm.deleteEvent($event)
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.selectedTag === "schedule"
      ? _c("div", { staticClass: "task-infos" }, [_c("ScheduleTag")], 1)
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }